import { Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { SaldoItemStatus, saldoItemStatusToColor } from '../SaldoItem';
import { CompanySelectMenuItemBoxWrapper, SuccessIconWrapper } from './styles';

type SelectItemIconProps = {
  status: SaldoItemStatus;
};

const SelectItemIcon = ({ status }: SelectItemIconProps) => {
  if (status === SaldoItemStatus.DANGER) {
    return <InfoIcon color={SaldoItemStatus.DANGER} />;
  }

  if (status === SaldoItemStatus.WARNING) {
    return <InfoIcon color={SaldoItemStatus.WARNING} />;
  }

  return <SuccessIconWrapper status={SaldoItemStatus.PRIMARY} />;
};

type SelectItemProps = {
  status: SaldoItemStatus;
  label: string;
};

export const SelectItem = ({ status, label }: SelectItemProps) => {
  return (
    <CompanySelectMenuItemBoxWrapper status={status}>
      <SelectItemIcon status={status} />
      <Typography color={saldoItemStatusToColor[status]}>{label}</Typography>
    </CompanySelectMenuItemBoxWrapper>
  );
};
